import React from 'react';
import { application } from '../../../services/application';
import Typography from '../../../components/common/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { useAlertContext } from '../../../contexts/AlertContext';
import { useTrans } from '../../../services/i18n';

const ResendTemporaryPassword = React.memo(({ email, onSent }) => {
  const [pendingResend, setPendingResend] = React.useState(false);
  const { successAlert, errorAlert, infoAlert } = useAlertContext();
  const { trans } = useTrans();

  return (
    <RouterLink
      onClick={
        pendingResend
          ? null
          : (e) => {
              e.preventDefault();
              setPendingResend(true);
              application
                .call('user.resendTemporaryPassword', {
                  email,
                })
                .then(() => {
                  successAlert(trans('temporary-password-resent-successfully'), trans('please-check-email'));
                  onSent?.();
                })
                .finally(() => {
                  setPendingResend(false);
                });
            }
      }
    >
      <Typography variant={'span'} color={pendingResend ? 'disabled' : undefined}>
        {trans('resend-temporary-password')}
      </Typography>
    </RouterLink>
  );
});

export default ResendTemporaryPassword;
